<template>
  <div v-if="show" class="card-body">
        <div class="row">
          <div class="col-lg-2 col-md-12 col-sm-12 form-control no-border">
            <span class="d-block mb-0 small text-muted  mb-2">
              {{$t( "communication.alertMessage.newMessage" )}}
            </span>
             <q-toggle
            v-model="importantTag"
            color="red"
            class="tw-custom-toggle ml-2"
          />
          </div>    
          <div class="col-lg-4 col-md-12 col-sm-12 form-control no-border">
            <span class="d-block mb-0 small text-muted  mb-2">
              {{$t( "communication.alertMessage.reference" )}}
              <span class="text-danger"> * </span>
            </span>
             <q-input 
                dense 
                outlined 
                v-model="reference"
                disable
                :loading="!reference" 
            />
            
          </div> 
           <div class="col-lg-4 col-md-12 col-sm-12 form-control no-border">
            <span class="d-block mb-0 small text-muted  mb-2">
              {{$t( "communication.alertMessage.subject" )}}
               <span class="text-danger"> * </span>
            </span>
             <searchable-select
              outlined
              bottom-slots
              v-model="subject"
              :options="subjects"
              :rules="[this.isRequired]"
              dense
              options-dense
              :loading="!subjects"
            >
              <template v-slot:append>
                <q-icon
                  v-if="subject"
                  name="cancel"
                  size="xs"
                  class="cursor-pointer"
                  @click.stop.prevent
                  @click="subject = null"
                />
              </template>
            </searchable-select> 
          </div> 
           <div class="col-lg-2 col-md-12 col-sm-12 form-control no-border" >
                    <span
                      class="d-block mb-0 small text-muted mb-2">{{$t( "communication.alertMessage.dateMessage")}}</span>
                    <q-input readonly v-model="dateMessage" outlined dense>
                        <template v-slot:append>
                            <q-icon name="event" class="cursor-pointer">
                                <q-popup-proxy ref="qDateProxy" cover tranitsion-show="scale" transition-hide="scale">
                                    <q-date v-model="dateAvis" :mask="$t('mask.format')" readonly>
                                        <div class="row items-center justify-end">
                                            <q-btn v-close-popup :label="$t(
        'task.completeDocument.party.person.financialSituation.close'
    )
        " color="primary" flat />
                                        </div>
                                    </q-date>
                                </q-popup-proxy>
                            </q-icon>
                        </template>
                    </q-input>
           </div> 
        </div>  
        <div class="row">
            <div class="col-lg-1 form-control no-border mt-3 d-flex align-items-center">
              <q-checkbox v-model="isInternRecipient" dense label="interne" class="small mr-1"/>
              <span class="text-danger">*</span>
            </div>
             <div class="col-lg-5 form-control no-border mt-2">
             <q-select
              outlined
              use-input
              multiple
              v-model="recipient"
              :options="optionsRecipients"
              :rules="[this.isComboRequired]"
              @filter="filterDest"
              @click.stop.prevent="abortDestFilter"
              dense
              options-dense
              emit-value
              map-options
              :loading="!optionsRecipients"
            >
               <template v-slot:before-options>
        <div class="theme-1">
          <div :class="'tw-wrapper-recipients-' + recipientType">
            <div
              class="align-items-center d-flex justify-content-end p-2"
              style="gap: 10px"
            >
              <span class="tw-recipient-selector-All" @click="recipientType = 'All'">
                {{ $t("communication.comMessage.All") }}
              </span>
              <span class="tw-recipient-selector-User" @click="recipientType = 'User'">
                {{ $t("communication.comMessage.User") }}
              </span>
              <span class="tw-recipient-selector-Group" @click="recipientType = 'Group'">
                {{ $t("communication.comMessage.Group") }}
              </span>
            </div>
          </div>
        </div>
               </template>
              <template v-slot:selected-item="scope">
                <q-chip
                  removable
                  dense
                  @remove="scope.removeAtIndex(scope.index)"
                  :tabindex="scope.tabindex"
                  color="white"
                  text-color="primary"
                  class="badge badge-primary d-flex"
                  @click.stop.prevent="abortDestFilter"
                >
                  <span class="mr-2 font-weight-normal">{{
                    $t(
                      "communication.comMessage.".concat(
                        getSelectedRecipientLabel(scope).context
                      )
                    )
                  }}</span>
                  -
                  {{ getSelectedRecipientLabel(scope).id }}
                </q-chip>
              </template>
              <template v-slot:option="scope">
                <div class="theme-1">
                  <div :class="'tw-wrapper-recipients-' + recipientType">
                  <div
                    class="border p-2"
                    :key="getSelectedRecipientLabel(scope)"
                    clickable
                    v-ripple
                    v-close-popup
                    v-bind="scope.itemProps"
                  >
                    <div class="d-flex align-items-center">
                      <span class="badge badge-primary">
                        {{
                          $t(
                            "communication.comMessage.".concat(
                              getSelectedRecipientLabel(scope).context
                            )
                          )
                        }}
                      </span>
                      <span class="ml-2">
                        {{ getSelectedRecipientLabel(scope).id }}
                      </span>
                    </div>
                  </div>
                  </div>
                </div>
              </template>
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-grey">
                    {{ $t("main.noResults") }}
                  </q-item-section>
                </q-item>
              </template>
            </q-select>
            </div>  
            <div class="col-lg-1 form-control no-border  mt-3">
                <q-checkbox v-model="isExternRecipient" dense  :label="'externe'" class="small mr-3"/>
            </div>
            <div class="col-lg-5 form-control no-border mt-2">
           
            <q-select
              outlined
              use-input
              multiple
              v-model="associatedRecipient"
              :options="orderParties"
              @filter="filterAssociatedDest"
              @click.stop.prevent="abortAssociatedDestFilter"
              dense
              options-dense
              emit-value
              map-options
              :loading="!orderParties"
            >
              <template v-slot:selected-item="scope">
                <q-chip
                  removable
                  dense
                  @remove="scope.removeAtIndex(scope.index)"
                  :tabindex="scope.tabindex"
                  color="white"
                  text-color="primary"
                  class="badge badge-primary d-flex"
                  @click.stop.prevent="abortAssociatedDestFilter"
                >
                  <span class="mr-2 font-weight-normal">{{
                    $t(
                      "demand.party.roles.".concat(
                        getSelectedAssociatedRecipientLabel(scope).context
                      )
                    )
                  }}</span>
                  -
                  {{ getSelectedAssociatedRecipientLabel(scope).id }}
                </q-chip>
              </template>
              <template v-slot:option="scope">
                <div class="theme-1">
                  <div
                    class="border p-2"
                    :key="getSelectedAssociatedRecipientLabel(scope)"
                    clickable
                    v-ripple
                    v-close-popup
                    v-bind="scope.itemProps"
                  >
                    <div class="d-flex align-items-center">
                      <span class="badge badge-primary">
                        {{
                          $t(
                            "demand.party.roles.".concat(
                              getSelectedAssociatedRecipientLabel(scope).context
                            )
                          )
                        }}
                      </span>
                      <span class="ml-2">
                        {{ getSelectedAssociatedRecipientLabel(scope).id }}
                      </span>
                    </div>
                  </div>
                </div>
              </template>
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-grey">
                    {{ $t("main.noResults") }}
                  </q-item-section>
                </q-item>
              </template>
            </q-select>
            </div>  
        </div>

        <div class="row">
            <div class="col-lg-6 form-control no-border ">
            <span class="d-block mb-0 small text-muted">
              {{$t( "communication.alertMessage.cc")}}
            </span>
            <q-input 
                dense 
                outlined 
                v-model="cc"  
                :rules="emailRules()"
            />
            </div>
        </div> 

        <div class="row">
            <div class="col-lg-12 form-control no-border mt-2 mb-2">
              <span class="d-block mb-0 small text-muted  mb-2">
              {{$t( "communication.alertMessage.message" )}}
              <span class="text-danger"> * </span>
               </span>
                <q-input 
                v-model="message" 
                outlined 
                type="textarea"  
                rows="1"
                :error-message="$t('communication.comMessage.missingField')" 
                :error="!message && message?.length <= 0"
                :placeholder="$t('communication.alertMessage.messagePlaceholder')"/>
            </div>
        </div>
        <div class="row">
             <div class="col-lg-6 col-md-12 col-sm-12 form-control no-border">
            <span class="d-block mb-0 small text-muted">
              {{$t( "communication.alertMessage.orderDocuments")}}
            </span>
             <q-select
              outlined
              use-input
              multiple
              v-model="documents"
              :options="partyDocuments"
              @filter="filterPartyDocument"
              @click.stop.prevent="abortPartyDocumentFilter"
              dense
              options-dense
              emit-value
              map-options
              :loading="!partyDocuments"
            >
              <template v-slot:selected-item="scope">
                <q-chip
                  removable
                  dense
                  @remove="scope.removeAtIndex(scope.index)"
                  :tabindex="scope.tabindex"
                  color="white"
                  text-color="primary"
                  class="badge badge-primary d-flex"
                  @click.stop.prevent="abortPartyDocumentFilter"
                >
                  <span class="mr-2 font-weight-normal">{{
                    $t(
                      "communication.comMessage.".concat(
                        getSelectedDocumentLabel(scope).context
                      )
                    )
                  }}</span>
                  -
                  {{ getSelectedDocumentLabel(scope).id }}
                </q-chip>
              </template>
              <template v-slot:option="scope">
                <div class="theme-1">
                  <div
                    class="border p-2"
                    :key="getSelectedDocumentLabel(scope)"
                    clickable
                    v-ripple
                    v-close-popup
                    v-bind="scope.itemProps"
                  >
                    <div class="d-flex align-items-center">
                      <span class="badge badge-primary">
                        {{
                          $t(
                            "communication.comMessage.".concat(
                              getSelectedDocumentLabel(scope).context
                            )
                          )
                        }}
                      </span>
                      <span class="ml-2">
                        {{ getSelectedDocumentLabel(scope).id }}
                      </span>
                    </div>
                  </div>
                </div>
              </template>
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-grey">
                    {{ $t("main.noResults") }}
                  </q-item-section>
                </q-item>
              </template>
            </q-select>
             </div>  
               <div class="col-lg-2 col-md-12 col-sm-12 form-control no-border mt-4">
                
                 <input type="file" id="fileUpload" @change="onSelectFile" accept=".pdf,.jpg,.jpeg,.png" style="display: none;" ref="fileInput"/>
                  <q-btn button
                    flat
                    class="my-custom-button"
                    :label="$t('communication.alertMessage.attachFile')"
                    @click="triggerFileInput"
                  />
                  </div>
                <div class="col-lg-4 col-md-12 col-sm-12 form-control no-border mt-4">
                 {{selectedFileName || $t('communication.alertMessage.noAttachedFile')}}
                </div>
        </div>
        <div class="text-right ">
              <q-btn
                :label="$t('communication.comMessage.sendBtn')"
                class="btn btn-primary"
                @click="sendMessage"
                 :disable ="onDisable"
              />
        </div>
  </div>   
</template>

<script lang="ts">
import i18n from "@/i18n";
import store from "@/store";
import { convertToUON, deepClone, Masks } from "@/utils";
import moment from "moment";
import { ref } from "vue";
import {Options, Vue} from "vue-class-component";
import {
  clientAppMsg,
  messageTemplate,
  objectType_odmTransferReplyMsg,
  typeMsg, recipient, Third} from "@/types";
import { getOrderParties } from "@/store/services/order/orderService";
const systemUid = `odm-contactmechanism`;


@Options({
  components: {  },
    props: [],
     watch: {
        "recipientType": {
            handler(newvalue) {
              let odm: any =this.filteredOptions
              if (newvalue) {
                this.optionsRecipients = odm === null 
                                         ? this.recipients.filter((item: any) => item.resourceUid)                               
                                         : this.recipients.filter((item: any) => item.resourceUid && item.objectType === odm)
              }
            },
            deep: true,
      }
      }
})
export default class MessageAlert extends Vue {
    dateMessage?: any = ref(moment().format("DD/MM/YYYY"));

  // variables
    optionsRefrence = [];
    optionsReference : any= [];
    showComDialog = false;
    importantTag = false;
    subject: any = null;
    destinations = [];
    message: any = i18n.global.t("communication.alertMessage.messagePlaceholder")           
     
    reference: any = null;
    recipient: any = [];
    associatedRecipient: any = null;
    isInternRecipient = true
    isExternRecipient = false
    selectedFile: any =null
    cc : any = null;
    documents: any = []
    partyDocuments: any = []
    partyDocuments2: any = []
    selectedFileName: any = null
    recipientType?: string = "All";
  get show() {
    return store.state.orderModule.showAlert;
  }

  toggleShowControls() {
    return store.dispatch('orderModule/toggleShow')
  }
  get subjects() {
     return store.state.messagingModule.subjects
     ? store.state.messagingModule.subjects?.map((item: any) => {
      return {
        value: item.id,
        label: item.id ? i18n.global.t("messageAlert.subjects." + item.id) : ''
      };
    })
    : []
  }
  get recipients() {
        return store.state.messagingModule.recipients && store.state.messagingModule.recipients.length ? store.state.messagingModule.recipients.filter((item: any) => item.objectType) : [];
  }
    optionsRecipients = this.recipients.filter((item: any) => item.resourceUid);
 
   updateResultRows(res: any) {
      this.optionsRefrence = res;
    }
   isRequired(val: string | any[]) {
      return (
        (val) ||
        i18n.global.t("communication.comMessage.missingField")
      );
    }
    isComboRequired(val: string | any[]) {
    return (
      (val && val.length > 0) || i18n.global.t("communication.comMessage.missingField")
    );
   } 
    get references() {
         return  this.optionsReference ? this.optionsReference : [];
    } 
    thirdName(third: Third) {
    if (third) {
      if (third.organization) {
        
        return third.organization.name;
      } else if (third.person) {
        return `${third.person.firstName} ${third.person.familyName}`;
      } else return "";
    }
   }
   get onDisable() {
    return !this.reference || !this.subject || this.recipient?.length===0 || !this.message  
  }  

   getAllEmails(thirds: any) {

  if (!thirds) return [];
   
  let emails:any  = [];
  for (const third of thirds){
    let emailContact: any  ;
    let email: any ;
   if (third.associatedParty && third.associatedParty.third && third.associatedParty.third.organization) {

     emailContact = third.associatedParty.third.organization && third.associatedParty.third.organization.contacts
                     ? third.associatedParty.third.organization.contacts?.filter((contact:any) => contact?.contactMechanism?.type?.id === 'EMAIL_CONTACT')[0]
                     : undefined

    email =  emailContact?.contactMechanism?.emailAddress || undefined
  }

  if (third.associatedParty && third.associatedParty.third && third.associatedParty.third.person) {

    emailContact = third.associatedParty.third.person && third.associatedParty.third.person.contacts
                     ? third.associatedParty.third.person.contacts?.filter((contact:any) => contact?.contactMechanism?.type?.id === 'EMAIL_CONTACT')[0]
                     : undefined
       email =  emailContact?.contactMechanism?.emailAddress || undefined
                                                

  }
    email ? emails.push(...emails,email) : null
  }
  
 
  return emails;
}
    getSelectedLabel(scope: any) {
    if (scope.opt && scope.opt.externalreference) {
      return {
        id: scope.opt && scope.opt.externalreference ? scope.opt.externalreference : scope.opt.orderItems[0] && scope.opt.orderItems[0].externalreference ? scope.opt.orderItems[0].externalreference : "",
        context: "Order",
      };
    }
    }
    getSelectedRecipientLabel(scope: any) {
    if (scope.opt?.username) {
      return {
        id: scope.opt.firstName + " " + scope.opt.lastName,
        context: "User",
      };
    }
    else {
      return {
        id: scope.opt?.resourceUid,
        context: "Group",
      };
    }
    }
    getSelectedAssociatedRecipientLabel(scope: any) {
    if (scope.opt && scope.opt.associatedParty && scope.opt.associatedParty.third) {
        const thirdName = this.thirdName(scope.opt.associatedParty.third)
      return {
         id: thirdName,
        context: scope.opt?.role_code
,
      }
    };
    }
    getSelectedDocumentLabel(scope: any) {
    if (scope.opt && scope.opt.label) {
      return {
        id: scope.opt && scope.opt.label ? scope.opt.label : "",
        context: "Document",
      };
    }
    }
  get order() {
    if (this.currentRoute === "order-edit") {
      return store.state.orderModule.order || {};
    } else if (this.currentRoute === "TaskDetail") {
      return store.state.taskModule.order || {};
    } else {
      return {};
    }
  }
  get orderReference() {
     if (this.currentRoute === "order-edit") {
      return store.state.orderModule.order?.reference || '';
    } else if (this.currentRoute === "TaskDetail") {
      return store.state.taskModule.order?.reference || '';
    } else {
      return '';
    }
  }
  get currentRoute() {
    return this.$router.currentRoute.value.name;
  }
   orderParties = store.state.orderPartyModule.orderParties ? store.state.orderPartyModule.orderParties : [];
  
    onSelectFile(event: Event, index: number) {
    const files = (event.target as HTMLInputElement).files as FileList;
    if (files.length > 0) {
        const file = files[0];
        this.selectedFileName = file ? file.name : i18n.global.t("communication.alertMessage.noAttachedFile");
        const creationDate = new Date().toLocaleDateString(); 
        const reader = new FileReader();
        reader.onload = () => {
            const content = (reader.result as string).split(',')[1];
            this.selectedFile = {
                    
                    creationDate,
                    label: file.name,
                    originalFileName: file.name,
                    format: file.type,
                    content,
                    }
        };
        reader.readAsDataURL(file);
    }
  }
  closeDialog() {
      this.toggleShowControls()
    }
   getParameters(obj: any) {
      if(obj.resourceUid){
        const entityId = store.getters["authModule/getSelectedUserNetwork"];
        return {
          Context: "ORDER",
          Entity_Reference: obj.orderItems[0] && obj.orderItems[0].externalReference ? obj.orderItems[0].externalReference : '',
          Entity_Daaq: obj.daaq,
          Entity_Status: obj.status.resourceUid,
          Entity_Id: entityId.value,
        };
      }else{
        return {
          Context: `${obj.id ? "PARTY" : "OFFER"}`,
          Entity_Reference: obj.reference,
          Entity_Daaq: obj._daaq,
          Entity_Status: `${
              obj.statuscode
                  ? obj.statuscode
                  : obj.current_status_code
          } `,
        };
      }
    }
  async sendMessage() {
      const _recipients: recipient[] = convertToUON(
          this.recipient
      );
      const senderUid = {
            objectType: "odm.user.leaseforgeuser",
            systemUid: "odm-user",
            resourceUid: this.$store.state.authModule?.user.userId,
        }

       const subject = {
            objectType: "odm.contactmechanism.messagesubject",
            systemUid: "odm-contactmechanism",
            resourceUid: this.subject &&  this.subject.value ? this.subject.value : null
        };
      clientAppMsg.resourceUid = "68815"; 

      if (
          this.subject &&
          this.recipients &&
          this.recipients.length > 0 &&
          this.message &&
          this.$store.state.authModule?.user.userId
      ) {
        _recipients.forEach((el: any) => {
          delete el.recipient.read_daaq
        })
        let  destinations = deepClone(_recipients)
        destinations.forEach((item: any) => {
          delete item.recipient.email
        }) 
        if (this.reference) {
           
          store
              .dispatch("messagingModule/messageSend", {
                objectType: objectType_odmTransferReplyMsg,
                systemUid,
                daaq: `${store.state.authModule?.daaq}${store.state.authModule?.daaqResourceUid}/${store.state.authModule?.daaqLabel}`,
                sender: `${store.state.authModule?.user.firstName} ${store.state.authModule?.user.lastName}`,
                senderUid: senderUid,
                priority: this.importantTag,
                subject: subject,
                type: typeMsg,
                recipients:destinations,
                body: this.message,
                relatedObjects: null, 
                clientApplication: clientAppMsg, 
                parameters: this.getParameters(this.order),

                messageTemplate: messageTemplate,
              })
              .then(() => {
                this.sendMail(); 
              });
              
        } 
      }
    }
    async sendMail (){
        const userRecipients = this.recipient.filter((r: any) => r && r.objectType === "odm.user.leaseforgeuser");
        if (userRecipients.length){
            let emailSendList : any =[]
            let emailSendPartyReferences : any =[]
            const emailSendRecipient = userRecipients && userRecipients.map((item:any) => item.email) ? userRecipients.map((item:any) => item.email) : [];
            const emailSendAssociatedRecipient = this.getAllEmails(this.associatedRecipient)  ? this.getAllEmails(this.associatedRecipient) : []      
            const emailSendCC = this.cc ? [this.cc] : [];      
            emailSendList = [...emailSendRecipient, ...emailSendAssociatedRecipient, ...emailSendCC];
             emailSendPartyReferences= this.documents && this.documents.map((item:any) => item) ? this.documents.map((item:any) => item) : [];   

            await store.dispatch('orderModule/sendMailWithDocument',{
                emailSendList: emailSendList,
                attachment: this.selectedFile || null,
                fileReference: emailSendPartyReferences && emailSendPartyReferences.length ?  emailSendPartyReferences : []
                }
            )
        }
        
    }
    emailRules() {
            return [
            (val:any) => (!val || Masks.emailMask.test(val))  || "Invalid email"
            ];
  }
   updateResulteRows(res: any) {
      this.optionsReference = res;
    }
  filterDest(val: any, update: any) {
      let odm: any =this.filteredOptions
    if (val === '') {
      update(() => { 
        this.optionsRecipients = odm === null 
                                ? this.recipients.filter((item: any) => item.resourceUid)                               
                                : this.recipients.filter((item: any) => item.resourceUid && item.objectType === odm)

      })
      return
    }

    update(() => {
      const needle = val.toLowerCase()
     const filteredList = this.optionsRecipients.filter((dest: any) => {
      if ("firstName" in dest) {
        return (
          dest.firstName.toLowerCase().includes(needle.toLowerCase()) ||
          dest.lastName.toLowerCase().includes(needle.toLowerCase()) ||
          dest.firstName.concat(' ').concat(dest.lastName).toLowerCase().includes(needle.toLowerCase()) ||
          dest.resourceUid.toLowerCase().includes(needle.toLowerCase())
        );
         } else {
        return (
          dest.resourceUid.toLowerCase().includes(needle.toLowerCase())
        );
      }
    });

    this.optionsRecipients = filteredList;
    })
  }
  get filteredOptions() {
    let odm: any =null;
    switch (this.recipientType) {
      case "All":
        odm = null;
        break;

      case "User":
        odm = "odm.user.leaseforgeuser";
        break;

      case "Group":
        odm = "odm.user.securitygroup";
        break;

      default:
        break;
    }
    return odm
   }
  abortDestFilter() {
    this.optionsRecipients =this.recipients.filter((item: any) => item.resourceUid);
  }
  filterAssociatedDest(val: any, update: any) {
    if (val === '') {
      update(() => {
        this.orderParties = store.state.orderPartyModule.orderParties ? store.state.orderPartyModule.orderParties : [];
      })
      return
    }
    update(() => {
      const needle = val.toLowerCase()
     let filteredList
         filteredList = this.orderParties.filter((dest: any) => {
              if (dest && dest.associatedParty && dest.associatedParty.third &&  dest.associatedParty.third.organization) {
                    if ("name" in dest.associatedParty.third.organization) {
                              return (
                                dest.associatedParty.third.organization.name.toLowerCase().includes(needle.toLowerCase())
                              );
                    }
              }
              else if (dest && dest.associatedParty && dest.associatedParty.third &&  dest.associatedParty.third.person) {
                    if ("firstName" in dest.associatedParty.third.person) {
                               return (
                                    dest.associatedParty.third.person.firstName.toLowerCase().includes(needle.toLowerCase()) ||
                                    dest.associatedParty.third.person.familyName.toLowerCase().includes(needle.toLowerCase()) ||
                                    dest.associatedParty.third.person.firstName.concat(' ').concat(dest.associatedParty.third.person.familyName).toLowerCase().includes(needle.toLowerCase())                                  );
                                }
                }
              
    });
    this.orderParties = filteredList;
    })
  }
  abortAssociatedDestFilter() {
    this.orderParties =store.state.orderPartyModule.orderParties ? store.state.orderPartyModule.orderParties : [];
  }

   filterPartyDocument(val: any, update: any) {
    if (val === '') {
      update(() => {
        this.partyDocuments = this.partyDocuments2;
      })
      return
    }
    update(() => {
      const needle = val.toLowerCase()
     const filteredList = this.partyDocuments.filter((dest: any) => {
      if ("label" in dest) {
        return (
          dest.label.toLowerCase().includes(needle.toLowerCase())
        );
      }
    });

    this.partyDocuments = filteredList;
    })
  }
  async abortPartyDocumentFilter() { 
        this.partyDocuments = this.partyDocuments2;
  }
   triggerFileInput() {
     
      const fileInput = this.$refs.fileInput as HTMLInputElement;  // Assertion de type
      fileInput.click(); // Ouvre la boîte de dialogue de sélection de fichier
    }

  async created(){
    if (this.currentRoute === "TaskDetail"){
       const orderParties = await getOrderParties(this.order?.orderParties)
       store.dispatch('orderPartyModule/setOrderParties', { orderParties: orderParties})
    }
      store.dispatch("messagingModule/fetchSubjects")
      store.dispatch("messagingModule/fetchRecipients")
      await store.dispatch("picklistModule/partyReceivedDocuments", {
      orderReference: this.orderReference,
      callback: (res: any) => {
        this.partyDocuments = res;
        this.partyDocuments2 =res
      }
      });
       
       this.optionsRefrence  = await new Promise((resolve) => {
        store.dispatch("demandModule/searchOfferPartyOrder", {
            callback: (res:any) => {
                resolve(res);
            },
           offerFilter: {},
           filterParty: {},
           orderFilter: {},
      });
    });
      this.optionsReference  =  this.optionsRefrence.filter((item: any) => item.orderid)
      this.reference = this.order && this.order.orderItems[0] && this.order.orderItems[0].externalReference 
                       ? this.order.orderItems[0].externalReference 
                       : this.order && this.order.reference 
                       ? this.order.reference
                       : ""
      
  }
 
}
</script>

<style scoped>
.my-custom-button {
  background-color: #EFEFEF;
  color: #333;
  border-radius: 5px;
  cursor: pointer;
  border: 1px solid #333;
   font-size: 13px; 
}
</style>
